var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"block-cell"},[_c('p',{staticClass:"block-cell-title"},[_c('span',[_vm._v(_vm._s(_vm.title))]),(_vm.isTip)?_c('img',{attrs:{"src":_vm.helpBlue},on:{"click":_vm.tipClick}}):_vm._e()]),_c('p',{staticClass:"block-cell-value"},[_vm._v("\n    "+_vm._s(_vm.value)+"\n  ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }